module.exports = __webpack_public_path__ + "static/media/cchub_logo_white.c13e9203.png";